import { addDays, addMonths, endOfDay, endOfMonth, startOfDay, startOfYear } from "date-fns";
import { TimeRange } from "./types";
import { CounterMedium } from "../../../Devices/CounterMedium";
import { CustomThemeT } from "../../../../theme/customTheme";
import { DisplayMode } from "../../../../hooks/useGetBuildingsEnergy";
import { IBaseCounter } from "../../../Devices/BaseCounter";
import { CounterType } from "../../../Devices/CounterType";

export function startEndDateFromTimeRange(timeRange: TimeRange) {

    switch (timeRange) {
        case TimeRange.Last30Days:
            return {
                start: startOfDay(addDays(new Date(), -30)),
                end: endOfDay(addDays(new Date(), -1))
            }
        case TimeRange.Last12Months:
            return {
                start: addDays(addMonths(endOfMonth(new Date()), -12), 1),
                end: endOfDay(addDays(new Date(), -1))
            }
        case TimeRange.YearToDate:
            return {
                start: startOfYear(new Date()),
                end: endOfDay(addDays(new Date(), -1))
            }
    }
}

export const getColor = (medium: CounterMedium | undefined, theme: CustomThemeT) => {
    if (medium === undefined)
        return theme.colors.accent;

    if (medium === CounterMedium.HeatMeter)
        return theme.appColors.medium.heat;

    if (medium === CounterMedium.ElectricityMeter)
        return theme.appColors.medium.electricity;

    if (medium === CounterMedium.ColdMeter)
        return theme.appColors.medium.cold;

    return theme.colors.accent;
}


export const getDisplayMode = (medium: CounterMedium | undefined) => {

    if (medium === CounterMedium.WaterMeter)
        return DisplayMode.M3;

    return DisplayMode.KWH;
}

export const getUnitFromDisplayMode = (displayMode: DisplayMode) => {

    if (displayMode === DisplayMode.M3)
        return 'm³';

    if (displayMode === DisplayMode.CO2)
        return 'kg';
    if (displayMode === DisplayMode.EUR)
        return '€';
    return 'kWh';
}

export function filterCounters(x: IBaseCounter, mediumFilter?: CounterMedium) {
    if (mediumFilter !== undefined)
        return x.counterMedium === mediumFilter && (x.counterType === CounterType.FeedIn || x.counterType === CounterType.FeedOut)
    return x.counterType === CounterType.FeedIn || x.counterType === CounterType.FeedOut
}